module.exports = __webpack_public_path__ + "static/media/PDQ.df11a66b.png";